import React, { useEffect, useState, useRef, useContext } from "react";
import "./AdministratoReport.scss";
import axiosInstance from "../../ReusableComponents/Axios";
import { format } from "date-fns";
import NSFLOgo from "../../ReusableComponents/Assessts/Images/NCLogo.png";
import { useSelector } from "react-redux";
import { LoadContext } from "../../ReusableComponents/LoadingContex";

const AdministratoReport = () => {
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
    const USYear = useSelector((state) => state.SelecYearData.SYear);
    const ReportsRef = useRef();
    const { SetLoad } = useContext(LoadContext);
    const [RCounts, SetRCounts] = useState([]);
    const [RCountBottm, SetRCountBottm] = useState([]);
    const [RDetailed, SetRDetailed] = useState([]);
    const [RankingData, SetRankingData] = useState([]);
    const FetchallAPIs = async () => {
        SetLoad(true);
        try {
            // , Ranking
            const [RCount, RDetails] = await Promise.all([

                axiosInstance.get(
                    `/NCLAdmin/Getadministratorcountreports?InstituteId=${items?.instituteId}&ContestcreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&SocietyId=0`,
                ),
                axiosInstance.get(
                    `/NCLAdmin/Getadministratordetailedreports?InstituteId=${items?.instituteId}&ContestcreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&SocietyId=0`,
                ),
                // axiosInstance.get(
                //     `/NCLAdmin/GetAdminReportRegionStateWiseRanking?ContestcreationId=${SelectDate?.value}&InstituteId=${items?.instituteId}&AssessmentTypeId=${SelectDate?.assessmentType}&SocietyId=0`,
                // ),

            ]);
            if (RCount?.data.length > 0) {

                const RCData = [
                    { title: "REGIONS", value: RCount?.data?.[0].regionCount, subtitle: "Regional offices", },
                    { title: "JNV SCHOOLS", value: RCount?.data?.[0].schoolCount, subtitle: "Across India", },
                    { title: "STATES / UTS", value: RCount?.data?.[0].stateCount, subtitle: `${RCount?.data?.[0].stateCount} States / UTS`, },
                    { title: "REGISTERED", value: RCount?.data?.[0].registered.toLocaleString("en-US"), subtitle: "Enrolled students", },
                    { title: "PARTICIPATED", value: RCount?.data?.[0].participation.toLocaleString("en-US"), subtitle: "Students assessed", },
                    { title: "AVG PARTICIPATION", value: ((RCount?.data?.[0].participation / RCount?.data?.[0].registered) * 100).toFixed(2) + "%", },
                ];
                // const RCBottom = [
                //     { title: "ALL SUBJECTS PERFORMANCE", value: RCount?.data?.[0].allSubPercentage, },
                //     ...(RCount?.data?.[0]?.english > 0 ? [{ title: "English PERFORMANCE", value: RCount?.data?.[0].english }] : []),
                //     ...(RCount?.data?.[0]?.mathematics > 0 ? [{ title: "Mathematics PERFORMANCE", value: RCount?.data?.[0].mathematics }] : []),
                //     ...(RCount?.data?.[0]?.science > 0 ? [{ title: "Science PERFORMANCE", value: RCount?.data?.[0].science }] : []),
                //     ...(RCount?.data?.[0]?.physicsandChemistry > 0 ? [{ title: "Physics and Chemistry PERFORMANCE", value: RCount?.data?.[0].physicsandChemistry }] : []),
                //     ...(RCount?.data?.[0]?.biology > 0 ? [{ title: "Biology PERFORMANCE", value: RCount?.data?.[0].biology }] : []),
                //     ...(RCount?.data?.[0]?.hindi > 0 ? [{ title: "Hindi PERFORMANCE", value: RCount?.data?.[0].hindi }] : []),
                //     ...(RCount?.data?.[0]?.telugu > 0 ? [{ title: "Telugu PERFORMANCE", value: RCount?.data?.[0].telugu }] : []),
                // ]
                const data = RCount?.data?.[0];

                const subjects = [
                    data?.english,
                    data?.mathematics,
                    data?.science,
                    data?.physicsandChemistry,
                    data?.biology,
                    data?.hindi,
                    data?.telugu
                ].filter(value => value > 0);

                const allSubjectsPercentage =
                    subjects.length > 0
                        ? subjects.reduce((sum, value) => sum + Number(value), 0) / subjects.length
                        : 0;

                const RCBottom = [
                    {
                        title: "OverAll",
                        value: Math.round(allSubjectsPercentage)
                    },

                    ...(data?.english > 0
                        ? [{ title: "English", value: data.english }]
                        : []),

                    ...(data?.mathematics > 0
                        ? [{ title: "Mathematics", value: data.mathematics }]
                        : []),

                    ...(data?.science > 0
                        ? [{ title: "Science", value: data.science }]
                        : []),
                    ...(data?.physicsandChemistry > 0
                        ? [{ title: "Physics and Chemistry", value: data.physicsandChemistry }]
                        : []),
                    ...(data?.biology > 0
                        ? [{ title: "Biology", value: data.biology }]
                        : []),
                    ...(data?.hindi > 0
                        ? [{ title: "Hindi", value: data.hindi }]
                        : []),
                    ...(data?.telugu > 0
                        ? [{ title: "Telugu", value: data.telugu }]
                        : []),
                ];
                SetRCounts(RCData);
                SetRCountBottm(RCBottom);
            } else {
                SetRCounts([]);
                SetRCountBottm([]);
            }

            //             if (RDetails?.data?.length > 0) {
            //                 const RDData = RDetails?.data.map((item) => (
            //                     {
            //                         region: item.regionName,
            //                         schools: item.totalSchools,
            //                         status: PerformanceStatus(((item.participationCount / item.registeredCount) * 100).toFixed(2)),
            //                         statusClass: "average",

            //                         participation: item.participationPercentage,
            //                         registered: item.registeredCount + " reg.",

            //                         // performance: ((item.participationCount / item.registeredCount) * 100).toFixed(2),
            //                         participated: item.participationCount + " part.",

            //                         subjects: [
            //                             ...(item?.english > 0 ? [{ title: "ENG", value: item.english }] : []),
            //                             ...(item?.mathematics > 0 ? [{ title: "MATH", value: item.mathematics }] : []),
            //                             ...(item?.science > 0 ? [{ title: "SCI", value: item.science }] : []),
            //                             ...(item?.physicsandChemistry > 0 ? [{ title: "P&C", value: item.physicsandChemistry }] : []),
            //                             ...(item?.biology > 0 ? [{ title: "BIO", value: item.biology }] : []),
            //                             ...(item?.hindi > 0 ? [{ title: "HIN", value: item.hindi }] : []),
            //                             ...(item?.telugu > 0 ? [{ title: "TEL", value: item.telugu }] : []),
            //                         ],
            // performance:subjects.length > 0
            //             ? (
            //                 // && value > 0
            //                 subjects.filter(value => value !== null && value !== undefined ).reduce(
            //                     (sum, value) => sum + Number(value), 0
            //                 ) / subjects.length
            //             ).toFixed(2)
            //             : "0.00"

            //                     }

            //                 ))
            //                 SetRDetailed(RDData);
            //             } else {
            //                 SetRDetailed([]);
            //             }
            if (RDetails?.data?.length > 0) {
                const RDData = RDetails.data.map((item) => {

                    // Get available subject percentages
                    const subjectValues = [
                        item?.english,
                        item?.mathematics,
                        item?.science,
                        item?.physicsandChemistry,
                        item?.biology,
                        item?.hindi,
                        item?.telugu
                    ].filter(value => value !== null && value !== undefined && Number(value) > 0);

                    // Calculate average performance percentage
                    const performance = subjectValues.length > 0
                        ? (
                            subjectValues.reduce(
                                (sum, value) => sum + Number(value),
                                0
                            ) / subjectValues.length
                        ).toFixed(2)
                        : "0.00";

                    const subjects = [
                        ...(item?.english > 0
                            ? [{ title: "ENG", value: item.english }]
                            : []),

                        ...(item?.mathematics > 0
                            ? [{ title: "MATH", value: item.mathematics }]
                            : []),

                        ...(item?.science > 0
                            ? [{ title: "SCI", value: item.science }]
                            : []),

                        ...(item?.physicsandChemistry > 0
                            ? [{ title: "P&C", value: item.physicsandChemistry }]
                            : []),

                        ...(item?.biology > 0
                            ? [{ title: "BIO", value: item.biology }]
                            : []),

                        ...(item?.hindi > 0
                            ? [{ title: "HIN", value: item.hindi }]
                            : []),

                        ...(item?.telugu > 0
                            ? [{ title: "TEL", value: item.telugu }]
                            : [])
                    ];

                    return {
                        region: item.regionName,
                        schools: item.totalSchools,
                        status: PerformanceStatus(
                            ((item.participationCount / item.registeredCount) * 100).toFixed(2)
                        ),
                        statusClass: "average",
                        participation: item.participationPercentage,
                        registered: item.registeredCount + " reg.",
                        participated: item.participationCount + " part.",
                        performance: performance,
                        subjects: subjects
                    };
                });

                SetRDetailed(RDData);
            } else {
                SetRDetailed([]);
            }
            const RankingData = [
                {
                    title: "▲ TOP 3 PARTICIPATION",
                    titleClass: "green-title",
                    valueClass: "green",
                    data: RDetails?.data.filter((item) => item?.participationCategory === "Top 3")
                },
                {
                    title: "▼ BOTTOM 3 PARTICIPATION",
                    titleClass: "red-title",
                    valueClass: "orange",
                    data: RDetails?.data.filter((item) => item?.participationCategory === "Bottom 3")
                },
                {
                    title: "▲ TOP 3 PERFORMANCE",
                    titleClass: "green-title",
                    valueClass: "green",
                    data: RDetails?.data.filter((item) => item?.performanceCategory === "Top 3")
                },
                {
                    title: "▼ BOTTOM 3 PERFORMANCE",
                    titleClass: "red-title",
                    valueClass: "red",
                    data: RDetails?.data.filter((item) => item?.performanceCategory === "Bottom 3")
                },
            ];
            SetRankingData(RankingData);

        } catch (err) {
            console.log(err);
        } finally {
            SetLoad(false);
        }
    };
    useEffect(() => {
        FetchallAPIs();
    }, [SelectDate]);

    const PerformanceStatus = (e) => {
        switch (true) {
            case e <= 50:
                return "HIGH";
            case e > 50 && e <= 74:
                return "AVERAGE";
            case e > 74:
                return "LOW";
        }
    }
    const Percentagecolor = (e) => {
        switch (true) {
            case e <= 50:
                return "#d63031";
            case e > 50 && e <= 74:
                return "#e67e22";
            case e > 74:
                return "#0f8b78";
        }
    };

     const PercentageBGcolor = (e) => {
        switch (true) {
            case e <= 50:
                return "#fdeaea";
            case e > 50 && e <= 74:
                return "#fff3e6";
            case e > 74:
                return "#e7f8f5";
        }
    };


    const replaceCanvasWithImages = () => {
        const canvases = document.querySelectorAll("canvas");
        canvases.forEach((canvas) => {
            const img = document.createElement("img");
            img.src = canvas.toDataURL("image/png");
            img.style.width = canvas.style.width;
            img.style.height = canvas.style.height;
            img.className = "chart-image";
            canvas.replaceWith(img);
        });
    };

    const copyAllStyles = () => {
        let styles = "";
        for (let sheet of document.styleSheets) {
            try {
                if (sheet.href) {
                    styles += `<link rel="stylesheet" href="${sheet.href}" />`;
                } else if (sheet.cssRules) {
                    // inline style blocks (used by SCSS injected styles)
                    let rules = "";
                    for (let rule of sheet.cssRules) {
                        rules += rule.cssText;
                    }
                    styles += `<style>${rules}</style>`;
                }
            } catch (err) {
                console.log("Skipping stylesheet", err);
            }
        }
        return styles;
    };

    const DownloadPDF = async () => {
        try {
            const payload = {
                userTypeId: items?.userTypeId || 0,
                userId: items?.userId || 0,
                reportType: "Institute Admin Report Card SODHANA",
                contestCreationId: SelectDate?.value || 0,
                assessmentTypeId: SelectDate?.assessmentType || 0
            };
            await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);

        } catch (error) {
            console.error("Error logging report download:", error);
        }
        const stylesheets = copyAllStyles();
        replaceCanvasWithImages();
        const printContents = ReportsRef.current.innerHTML;
        const printWindow = window.open("", "", "height=800,width=600");
        const filename = `NCP_ ADMIN ReportCard`;
        //   const filename = `NCP_ReportCard_${items?.fullName}_${AssessmentName(
        //     location?.state?.AType,
        // )}_${location?.state?.Date}`;
        printWindow.document.write(`
    <html>
      <head>
      ${stylesheets}
        <style>
          @media print {
            body {
            font-size: 12px;
              position: relative;
               -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
  background-color: #fff !important;
            }
           
  .print-only {
    display: block !important;
  }
    
    table th {
     font-size: 12px;

  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
  table tbody td,.ft-18 {
  font-size: 12px !important;
}
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 80px;
              color: rgba(0, 0, 0, 0.06); /* low opacity */
              pointer-events: none;
              z-index: 9999;
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  gap: 20px;
}
.top-cards{
    grid-template-columns:repeat(6,1fr);
    gap:1px;
}
    .top-cards h1,.bottom-cards h2,
    .participation h1,.performance h1
    {
    font-size: 18px;}

     .top-cards h4,.top-cards p,
     .participation h5,.performance h5,.participation p,.performance p
      {
    font-size: 14px;}
    .card-header h3{
    font-size: 12px;
    }
.bottom-cards h5{
font-size: 10px;
font-weight: bold;
}
    .bottom-cards{
    grid-template-columns:repeat(6,1fr);
}
   .region-grid{
    grid-template-columns:repeat(3,1fr);
   }

.stats .participation,.stats .performance{
padding:10px}
.subjects span{
font-size: 10px;
}
.subjects strong{
font-size: 12px;
}
.subjects div {
padding:5px
}
    .stats{
    grid-template-columns:repeat(2,1fr);
}
    .ranking-grid{
    grid-template-columns:repeat(4,1fr);
}
    .ranking-grid h3{
    font-size: 12px;
    }
    .subjects{
    grid-template-columns:repeat(5,1fr);
}
.Icons-Div div {
  flex: 1;
}
 .Icons-Div > img {
    width: 20%;
    flex-shrink: 0;
}

.Icons-Div > div:first-of-type {
    flex: 1;
    text-align: center;
}

.Icons-Div > div:last-of-type {
    flex: 0 0 auto;
    text-align: right;
}
  .number, .subjects{
    page-break-inside: avoid;
}

                   .EndReport{
                  margin-top: 15px;
              }
                   .SubHeading,.MainHeading{
 font-weight:700 !important;
 font-size: 14px;}

            @page {
              size: A4;
              margin: 7mm;
            }
          }
        </style>
      </head>
      <body>
<div class="p-3 Icons-Div" style="background-color:#2f7f72;color:#FFF">
                    
                       <img src="${NSFLOgo}" alt="NSF Logo"/>

                    <div className="dflex alignitems flexd-column">
                        <div className="MainHeading">ADMINISTRATOR REPORT CARD</div>
                        <div className="SubHeading mt-2"> Navodaya Vidyalaya Samiti (NVS) • National Overview </div>
                        <p className="year"> ${SelectDate?.display} • Academic Year ${USYear?.display}</p>
                    </div>

                    <div>
                        <span className="prepared">PREPARED FOR</span>
                        <div>Commissioner, NVS HQ</div>
                    </div>
                </div>
        <div class="watermark">NORTH SOUTH FOUNDATION</div>
   
      ${printContents}
  
     
<div className="dflex flexd-column">
      <span className="">
      For region, JNV and student-level drilldowns, visit the live administrator dashboard:
      </span>

      <span style="color: #2563EB" >https://sadhana-nvs.northsouth.org/ </span>
    </div>

      <script>
          window.onload = function() {
            setTimeout(() => {
              document.title = "${filename}";
              window.print();
              window.close();
              }, 400);
              }
              <\/script>
              </body>
              </html>
              `);
        printWindow.document.close();
    };

    return (
        <div className="TeacherBgImage">
            <div className="dflex JSBetween mb-2">
                <div></div>
                {RDetailed.length > 0 &&
                    <button className="Buttons p-2" onClick={() => { DownloadPDF() }}> Download Report</button>}
            </div>

            <div className="header dflex alignitems JSBetween ">
                <div className=""> </div>

                <div className="dflex alignitems flexd-column" style={{position:"relative",left:"5%"}}>
                    <div className="MainHeading">ADMINISTRATOR REPORT CARD</div>
                    <div className="SubHeading mt-2"> Navodaya Vidyalaya Samiti (NVS) • National Overview </div>
                    <p className="year"> {SelectDate?.display} • Academic Year {USYear?.display}</p>
                </div>

                <div>
                    <span className="prepared">PREPARED FOR</span>
                    <div>Commissioner, NVS HQ</div>
                </div>
            </div>
            <div ref={ReportsRef}>
                {RDetailed.length > 0 ? <>
                    <div className="">
                        <div className="dflex JSBetween mt-3 mb-2">
                            <div className="MainHeading">Executive Summary</div>
                            <div className="report-date dflex alignitems gap-2">
                                <span>REPORT GENERATED:</span>
                                <strong>{format(new Date(), "MMMM dd, yyyy")}</strong>
                            </div>
                        </div>

                        <div className="dflex JSBetween">
                            <span> National rollup of Sodhana 1 — system overview, participation,
                                performance and subjects across all 9 NVS regions. </span>
                            <div className="dflex gap-3">
                                <div className="dflex alignitems legend-item gap-2">
                                    <span className="dot " style={{ backgroundColor: "#0f8b78" }}></span>
                                    <p>High (&gt;75%)</p>
                                </div>

                                <div className="dflex alignitems legend-item gap-2">
                                    <span className="dot" style={{ backgroundColor: "#e67e22" }} ></span>
                                    <p>Avg (50-74%)</p>
                                </div>

                                <div className="dflex alignitems legend-item gap-2">
                                    <span className="dot" style={{ backgroundColor: "#d63031" }}></span>
                                    <p>Low (&lt;50%)</p>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>

                    <section className="">
                        <div className="section-heading dflex alignitems gap-2 mb-2">
                            <div className="number">1</div>
                            <div className="SubHeading">SYSTEM OVERVIEW</div>
                            <span >{SelectDate?.display} | National rollup</span>
                        </div>

                        <div className="top-cards gap-3">
                            {RCounts.map((card, index) => (
                                <div className="card" key={index}>
                                    <h4 className="mb-1">{card.title}</h4>
                                    <h1 className="mb-1"><b>{card.value}</b></h1>
                                    <p>{card.subtitle}</p>
                                </div>
                            ))}
                        </div>
                        <div className="SubHeading mt-3">Performance</div>
                        <div className="bottom-cards mt-2">
                            {RCountBottm.map((item, index) => (
                                <div className="performance-card" key={index}>
                                    <h5 className="mb-1">{item.title}</h5>
                                    <h2 style={item.title !== "AVG PARTICIPATION" ? { color: Percentagecolor(item.value) } : { color: "#2563eb" }}><b>{item.value}%</b></h2>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="mt-3">
                        <div className="section-heading dflex alignitems gap-3 mb-3">
                            <div className="number">2</div>
                            <div className="SubHeading">REGION SCORECARDS</div>
                            <span>participation | performance | subjects</span>
                        </div>
                        <div className="region-grid gap-3">
                            {RDetailed.map((item, index) => (
                                <div className="region-card" key={index}>
                                    <div className="card-header dflex JSBetween p-3">
                                        <div>
                                            <h3 className="p-0 mt-0 mb-1">{item.region}</h3>
                                            <span className="school-tag"> {item.schools} JNV SCHOOLS </span>
                                        </div>
                                        <span className={`status ${item.statusClass}`}> {item.status} </span>
                                    </div>

                                    <div className="stats">
                                        <div className="participation">
                                            <h5>PARTICIPATION</h5>
                                            <h1><b>{item.participation}%</b></h1>
                                            <p>{item.registered}</p>
                                        </div>

                                        <div className="performance">
                                            <h5>PERFORMANCE</h5>
                                            <h1><b>{item.performance}%</b></h1>
                                            <p>{item.participated}</p>
                                        </div>
                                    </div>

                                    <div className="subjects">
                                        {item.subjects.map((Sub) => (
                                            <div>
                                                <span>{Sub.title}</span>
                                                <strong style={{ color: Percentagecolor(Sub.value) }}>{Sub.value}%</strong>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="mt-3">
                        <div className="section-heading gap-3 dflex alignitems">
                            <div className="number">3</div>
                            <div className="SubHeading">REGIONAL RANKINGS</div>
                            <span>participation, then performance | top & bottom 3</span>
                        </div>
                        <div className="ranking-grid gap-3">
                            {RankingData.map((table, index) => (
                                <div key={index}>
                                    <h3 className={table.titleClass}>{table.title}</h3>
                                    <table className="ranking-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>REGION</th>
                                                <th>Percentage</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {table.data.map((row, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{row.regionName}</td>
                                                    {/* className={table.valueClass} */}
                                                    <td  style={{color:Percentagecolor(table.title.includes("PARTICIPATION") ? row.participationPercentage : row.averagePercentage),
                                                        backgroundColor:PercentageBGcolor(table.title.includes("PARTICIPATION") ? row.participationPercentage : row.averagePercentage),
                                                        textAlign:"center",fontWeight:"bold"
                                                    }}>{table.title.includes("PARTICIPATION") ? row.participationPercentage : row.averagePercentage}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                        </div>
                    </section>
                </> :
                    <div className="ErrorMessage Card"> {process.env.REACT_APP_NODATAFOUND_Participated} </div>
                }
            </div>
        </div>
    )
}
export default AdministratoReport;